'use strict';

module.exports.symbolLookup = function () {
    return `
        <div rv-if="data.showtool">
            <input class="m-quote-media-symbol-lookup--hidden-input"
                rv-on-input="data.doLookup"
                rv-on-focus="data.doLookup"
                rv-on-click="data.doLookup"
                rv-value="data.symbollookupvalue"
                style="display: none"
                aria-hidden="true"
            />
        </div>
        <div class="m-quote-media-symbol-lookup--results" rv-if="data.showResults">
            <div class="m-quote-media-symbol-lookup--search-by-types">
                <div>
                    <input id="m-quote-media-symbol-lookup--search-by-symbol"
                        type="radio"
                        name="search-by"
                        value="symbol"
                        rv-checked="data.searchBy"
                        rv-on-change="data.doLookup"
                    />
                    <label rv-class-qmod-active="data.searchBy|= 'symbol'"
                        for="m-quote-media-symbol-lookup--search-by-symbol"
                    >
                        <span>{tplLang.searchby | toLang tLang}&nbsp;</span>
                        <span>{tplLang.symbol | toLang tLang} </span>
                    </label>
                </div>
                <div>
                    <input id="m-quote-media-symbol-lookup--search-by-name"
                        type="radio"
                        name="search-by"
                        value="name"
                        rv-checked="data.searchBy"
                        rv-on-change="data.doLookup"
                    />
                    <label rv-class-qmod-active="data.searchBy|= 'name'"
                        for="m-quote-media-symbol-lookup--search-by-name"
                    >
                        <span>{tplLang.searchby | toLang tLang}&nbsp;</span>
                        <span>{tplLang.name | toLang tLang}</span>
                    </label>
                </div>
            </div>
            <ul class="m-quote-media-symbol-lookup--result-tabs">
                <li rv-each-result="data.result | groupby 'symbolType' | propertyList"
                    rv-on-click="data.switchResultsTab"
                    rv-data-key="result.key"
                    rv-class-qmod-active="data.activeResultTab | = result.key"
                    rv-class-m-quote-media-symbol-lookup--active="data.activeResultTab | = result.key"
                >
                    <div>
                        <div>{result.key | i8ln tLang}</div>
                    </div>
                </li>
            </ul>
            <section rv-each-result="data.result | groupby 'symbolType' | propertyList"
                rv-show="data.activeResultTab | = result.key"
            >
                <table class="m-quote-media-symbol-lookup--result-list">
                    <tr rv-each-dataset="result.value"
                        rv-data-lookupresult="dataset |stringify"
                        rv-on-click="data.lookupCallback"
                    >
                        <td class="m-quote-media-symbol-lookup--textl">{dataset.symbol}</td>
                        <td class="m-quote-media-symbol-lookup--textl">{dataset.name}</td>
                        <td class="m-quote-media-symbol-lookup--textr">{dataset.countryCode}</td>
                        <td class="m-quote-media-symbol-lookup--textr">{dataset.exchange}</td>
                    </tr>
                </table>
            </section>
        </div>
    `;
};
